import React from 'react'
import { useWillPipe } from '@morningtrain/react-helpers'
import useCartContent from 'services/cart/hooks/use-cart-content'

export default function AddOrderToPayloadOnPipe (props) {
  const cartContent = useCartContent()

  useWillPipe(payload => new Promise(resolve => {
    const content = []

    for (const row of cartContent.entries()) {
      content.push({
        id: row[1].get('id'),
        quantity: row[1].get('quantity')
      })
    }

    payload.order = {
      domains: content
    }

    resolve(payload)
  }), [cartContent])

  return null
}
